import { TefHubApi } from "../../external";

class TefHubService {
  constructor() {}

  callback(body) {
    return new TefHubApi("/api/tef/callback").post(body);
  }

  fetchIniFileInfo() {
    return new TefHubApi("/api/tef/ini-info").get();
  }

  updateIniFileInfo(body) {
    return new TefHubApi("/api/tef/ini-info").put(body);
  }

  imprimirComprovante(body) {
    return new TefHubApi("/api/tef/imprimir").post(body);
  } 
}

export default TefHubService;
